<template>
  <div v-loading="loading" class="detailContainer">
    <el-timeline>
      <el-timeline-item
        v-for="(item, index) in tableData" :key="index" :timestamp="item.createTime"
        placement="top"
      >
        <el-card>
          <el-form :model="item" class="operationData">
            <!--操作ip-->
            <el-form-item
              prop="ip"
              :label="$t('basicData.OperationalIP') + '：'"
            >
              <div>{{ item.ip }}</div>
            </el-form-item>
            <!--操作人姓名-->
            <el-form-item
              prop="operatorName"
              :label="$t('basicData.OperatorName') + '：'"
            >
              <div>{{ item.operatorName }}</div>
            </el-form-item>
            <!--操作时间-->
            <el-form-item
              prop="createTime"
              :label="$t('basicData.OperationTime') + '：'"
            >
              <div>{{ item.createTime }}</div>
            </el-form-item>
            <!--操作内容-->
            <el-form-item
              prop="operationContent"
              :label="$t('basicData.ActionContent') + '：'"
            >
              <div v-for="(list, ind) in item.operationContent.split('\n')" :key="ind">
                {{ list }}
                <!--下载报价-->
                <span
                  v-if="item.extra && ind === (item.operationContent.split('\n').length - 1)"
                  style="color: #00A551;cursor: pointer;"
                  @click="downloadQuote(item.extra)"
                >{{ $t('basicData.DownloadTheQuote') }}</span>
              </div>
            </el-form-item>
          </el-form>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { apiPayableOfferPriceOperateLog } from '@/api/finance/basicData';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';
import { downloadFile } from './downloadFile';

export default {
  name: 'OperationLog',
  mixins: [toolRequestClass],
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      tableData: [],
      createUser: [],
      loading: false
    };
  },
  watch: {
    editData: {
      handler(val) {
        this.getExpenseTypeList({
          state: 1, // 启用
          attribute: 2, // 应付
          accountType: 1, // 应付科目
          businessType: val.businessType
        });
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.createUser = getUserIdAndNameObj();
    this.getLogTable();
  },
  methods: {
    // 下载报价
    downloadQuote(data) {
      const dataArr = JSON.parse(data);
      const { detailData, detailData2, mainData, otherData } = dataArr;
      console.log(detailData, detailData2, mainData, otherData, '应付报价', dataArr);
      downloadFile(mainData, detailData, detailData2, otherData, this.expenseTypeList, this.specialFeeList);
    },
    // 获取操作日志
    getLogTable() {
      this.loading = true;

      const dateData = (property, bol) => {
        return function(a, b) {
          const value1 = a[property];
          const value2 = b[property];
          if (bol) {
            // 升序
            return Date.parse(value1) - Date.parse(value2);
          } else {
            // 降序
            return Date.parse(value2) - Date.parse(value1);
          }
        };
      };
      apiPayableOfferPriceOperateLog(this.editData.id).then(res => {
        if (res.code === 200) {
          res.data.map(item => {
            item.createTime = item.createTime.replace(/T|Z/g, ' ');
          });
          res.data.sort(dateData('createTime', false));
          this.tableData = res.data;
        }
      }).finally(
        () => {
          this.loading = false;
        }
      );
    }
  }
};
</script>

<style scoped>
.detailContainer {
  height: calc(100vh - 40px);
  overflow-y: auto;
  padding: 20px;
}
.el-timeline{
  padding: 0;
}
.el-form-item{
  margin-bottom: 0;
}
.detailContainer >>> .operationData .el-form-item__label,
.detailContainer >>> .operationData .el-form-item__content{
  line-height: 26px!important;
}
pre {
  white-space: pre-wrap;      /* css-3 */
  white-space: -moz-pre-wrap;  /* Mozilla, since1999 */
  white-space: -o-pre-wrap;    /*Opera 7 */
  word-wrap:break-word;       /* Internet Explorer 5.5+ */
  margin: 0;
  font-family: inherit;
  max-width: 600px;
}
</style>
